@if ((isExtendingTeamsToast$ | async) && toastTabItems?.length) {
  <div class="task-body extended-teams-toast">
    <div class="task-trigger-content">
      <div class="tab-page">
        <nimbus-material-tabs-wrapper>
          @for (tabItem of toastTabItems; track tabItem.id) {
            <nimbus-material-tab [model]="tabItem" (tabSelect)="navigateToastTab(tabItem?.id)"> </nimbus-material-tab>
          }
        </nimbus-material-tabs-wrapper>
        <div class="tab-form-body">
          <div class="tab-content">
            @if (isToastTabActive('flow')) {
              <app-task-flow-tab [task]="incomingTaskLive$ | async"></app-task-flow-tab>
            }
            @if (isToastTabActive('context')) {
              <app-task-context-tab [task]="incomingTaskLive$ | async"></app-task-context-tab>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  @if (showBanner$ | async) {
    <app-banner></app-banner>
  }
  <div class="task-body">
    <router-outlet></router-outlet>
    @if (showIncomingOverlay$ | async) {
      <app-task-incoming-overlay [task]="incomingTask$ | async"></app-task-incoming-overlay>
    }
  </div>
  @if (showFooter$ | async) {
    <app-footer></app-footer>
  }
}
